"use client";

import { find, includes } from "lodash";
import { useMemo } from "react";

import { AiRequest } from "@/.gql/graphql";

export const useCardData = (
  items: AiRequest[],
  currentId: string,
  undressIds: string[],
) =>
  useMemo(
    () =>
      find(
        items,
        (item) => item.id === currentId || includes(undressIds, item.id),
      ),
    [items, currentId, undressIds],
  );
